import { render, staticRenderFns } from "./headerCom.vue?vue&type=template&id=bbbfb468&scoped=true&"
import script from "./headerCom.vue?vue&type=script&lang=ts&"
export * from "./headerCom.vue?vue&type=script&lang=ts&"
import style0 from "./headerCom.vue?vue&type=style&index=0&id=bbbfb468&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbfb468",
  null
  
)

export default component.exports